import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { List, X } from "@phosphor-icons/react";
import { SITE } from "@/config/site";
import Logo from "@/components/Logo";

const navLinks = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/pricing", label: "Pricing", testid: "nav-pricing" },
  { to: "/faq", label: "FAQ", testid: "nav-faq" },
];

export default function PublicNav() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <header className="glass-header sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
        <Logo testid="logo-home-link" />

        <nav className="hidden md:flex items-center gap-7 text-sm text-[#4F5D4F]">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-[#132A13]" data-testid={l.testid}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          {user ? (
            <Link
              to="/dashboard"
              className="btn-secondary !py-2 !px-4 text-sm"
              data-testid="nav-dashboard-link"
            >
              Dashboard
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="btn-ghost text-sm hidden sm:inline-flex"
                data-testid="nav-login"
              >
                Sign in
              </Link>
              <Link
                to={SITE.LENDING_ENABLED ? "/register" : "/#waitlist"}
                className="btn-primary !py-2 !px-4 text-sm"
                data-testid="nav-register"
              >
                {SITE.LENDING_ENABLED ? "Get started" : "Join waitlist"}
              </Link>
            </>
          )}
          <button
            onClick={() => setOpen((o) => !o)}
            className="md:hidden p-2 -mr-2"
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={22} /> : <List size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E3DB] bg-white" data-testid="nav-mobile-panel">
          <nav className="px-5 py-4 flex flex-col gap-3 text-sm">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="py-1 text-[#132A13]"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
